<!-- Crear un boton al que se le pase solo la clase y el texto  -->
<button *ngIf="!lectura"[class]="clase" [disabled]="deshabilitado">
  <i *ngIf="usaIcono" [class]="claseIcono"></i>
  {{nombre |translate}}
</button>
